import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import usePageMeta from "@/lib/usePageMeta";

export default function Tietosuoja() {
  usePageMeta({
    title: "Tietosuojaseloste | MyyntiDrive Oy",
    description: "MyyntiDrive Oy:n tietosuojaseloste – rekisterinpitäjä, kerättävät tiedot, käyttötarkoitus, säilytysaika ja rekisteröidyn oikeudet.",
    ogTitle: "Tietosuojaseloste – MyyntiDrive Oy",
    ogDescription: "Miten käsittelemme henkilötietoja MyyntiDrivessä.",
  });

  return (
    <div className="min-h-screen bg-[#0B0D10] text-white" data-testid="tietosuoja-page">
      <Navbar />
      <main className="pt-32 md:pt-40 pb-24">
        <div className="md-container max-w-3xl">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors" data-testid="back-link">
            <ArrowLeft size={16} /> Takaisin etusivulle
          </Link>
          <div className="mt-8">
            <span className="md-eyebrow">Lakisääteinen dokumentti</span>
          </div>
          <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter">
            Tietosuojaseloste
          </h1>
          <p className="mt-4 text-sm text-white/50">Päivitetty: {new Date().toLocaleDateString("fi-FI")}</p>

          <div className="mt-12 space-y-10 text-white/80 leading-relaxed">
            <section>
              <h2 className="font-display text-xl md:text-2xl font-semibold text-white mb-3">1. Rekisterinpitäjä</h2>
              <p>MyyntiDrive Oy<br />Y-tunnus: 3645516-2<br /><a href="mailto:info@myyntidrive.fi" className="text-[#00E5FF] hover:text-white">info@myyntidrive.fi</a></p>
            </section>

            <section>
              <h2 className="font-display text-xl md:text-2xl font-semibold text-white mb-3">2. Mitä tietoja kerätään</h2>
              <p>Yhteydenottolomakkeen kautta keräämme seuraavat tiedot:</p>
              <ul className="mt-3 space-y-1 list-disc list-inside text-white/70">
                <li>Nimi</li>
                <li>Yritys</li>
                <li>Puhelinnumero</li>
                <li>Sähköposti</li>
                <li>Vapaa viesti</li>
              </ul>
            </section>

            <section>
              <h2 className="font-display text-xl md:text-2xl font-semibold text-white mb-3">3. Käyttötarkoitus</h2>
              <p>Tietoja käytetään yhteydenottopyyntöön vastaamiseen ja tarjouksen tekemiseen.</p>
            </section>

            <section>
              <h2 className="font-display text-xl md:text-2xl font-semibold text-white mb-3">4. Käsittelyn peruste</h2>
              <p>Käsittelyn peruste on oikeutettu etu (asiakassuhteen luominen) ja rekisteröidyn suostumus.</p>
            </section>

            <section>
              <h2 className="font-display text-xl md:text-2xl font-semibold text-white mb-3">5. Säilytysaika</h2>
              <p>Yhteydenotot säilytetään 12 kuukautta. Asiakassuhteen tiedot säilytetään sopimuksen ajan ja 6 vuotta sen päättymisestä kirjanpitolain mukaisesti.</p>
            </section>

            <section>
              <h2 className="font-display text-xl md:text-2xl font-semibold text-white mb-3">6. Tietojen luovutus</h2>
              <p>Tietoja ei luovuteta kolmansille osapuolille eikä siirretä EU:n ulkopuolelle.</p>
            </section>

            <section>
              <h2 className="font-display text-xl md:text-2xl font-semibold text-white mb-3">7. Rekisteröidyn oikeudet</h2>
              <p>Rekisteröidyllä on oikeus tarkastaa, oikaista ja poistaa omat tietonsa sekä tehdä valitus tietosuojavaltuutetun toimistolle.</p>
            </section>

            <section>
              <h2 className="font-display text-xl md:text-2xl font-semibold text-white mb-3">8. Yhteydenotot tietosuoja-asioissa</h2>
              <p><a href="mailto:info@myyntidrive.fi" className="text-[#00E5FF] hover:text-white">info@myyntidrive.fi</a></p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
